module.exports = {
      id: "search-white-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#search-white",
      toString: function () {
        return this.url;
      }
    }